<template>
    <div>
        <div class="sub-system-list">
            <div class="sub-system-list-warpper">
                <div class="sub-system-item-box" v-for="item in datalist">
                    <div class="sub-system-item-btn">
                        <div>
                            <el-button size="mini" type="warning" icon="el-icon-edit" @click="edit(item)">编辑</el-button>
                        </div>
                        <div>
                            <el-button size="mini" icon="el-icon-delete" type="danger" @click="remove(item)">删除</el-button>
                        </div>
                    </div>
                    <div class="sub-system-item-cont">
                        <div class="sub-system-item-version">
                            <strong>SDK版本：</strong>
                            <span v-html="item.version"></span>
                        </div>
                        <div class="sub-system-item-desc">
                            <strong>SDK描述：</strong>
                            <span v-html="item.detail" :title="item.detail"></span>
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
        </div>
        <el-dialog
            title="编辑版本信息"
            :visible.sync="dialogVisible"
            width="600px"
            :close-on-click-modal="false"
        >
            <el-form class="sub-system-search-from" ref="form" :model="form" label-width="80px">
                <el-form-item label="SDK版本">
                    <el-input style="width: 85%;" size="small" v-model="form.version" placeholder="SDK版本"></el-input>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input type="textarea" size="small" style="width: 85%;" v-model="form.detail" placeholder="描述"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="onSubmit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';

    export default {
        name       : 'sub-system-list',
        props: ['datalist'],
        data(){
            return {
                dialogVisible: false,
                form: {
                    version: '',
                    detail: '',
                },
                itemData: {},
            }
        },
        components : {},
        computed: {
            ...mapState(['$md5', '$base64', '$page', '$config', '$lodash', '$helper', '$i18n', '$moment','$route']),
        },

        created() {

        },

        watch: {
            datalist(val){
                console.log(val)
            }
        },

        methods: {
            ...mapActions(['ALERT_HANDLE']),
            ...mapActions('systemSdkVersion', ['REMOVE_BASE_VERSION', 'EDIT_BASE_VERSION']),

            edit(item){
                this.form.version = item.version;
                this.form.detail = item.detail;
                this.itemData = item;
                this.dialogVisible = !this.dialogVisible;
            },

            onSubmit() {
                let reg = /^[0-9\.]{2,}$/;

                if (!this.$helper.helper.tirm(this.form.version)) {
                    this.ALERT_HANDLE({message: '版本号不能为空！例如: 5.2.0'});
                    return false;
                }

                if (!this.$helper.helper.tirm(this.form.detail)) {
                    this.ALERT_HANDLE({message: '版本描述不能为空！'});
                    return false;
                }

                if (!reg.test(this.form.version)) {
                    this.ALERT_HANDLE({message: '版本号只能包含数字和点，例如: 5.2.0'});
                    return false;
                }

                /**
                 * 编辑版本号
                 */
                this.EDIT_BASE_VERSION({data: this.form, item: this.itemData, callback(){
                    this.dialogVisible = !this.dialogVisible;
                    this.form.version = '';
                    this.form.detail = '';
                    this.from.sdk_version_id = '';
                    this.from.platform = '';
                }});
            },

            remove(item){
                this.$confirm('确认删除当前版本号吗？','提示')
                .then(()=>{
                    this.REMOVE_BASE_VERSION(item);
                }).catch((res)=>{
                    console.log(res)
                });
            }
        }
    };
</script>

<style type="scss" scoped>
    .sub-system-list {

        width: 100%;
        overflow: hidden;
    }

    .sub-system-list * {
        box-sizing: content-box !important;
    }

    .sub-system-list-warpper {
        width: 110%;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;
    }
    .sub-system-item-box {
        background: #f4f4f4;
        width: 29.3%;
        margin-bottom: 15px;
        margin-right: 20px;
    }

    .sub-system-item-cont {
        height: 70px;
        background: #fff;
        margin: 10px 110px 10px 10px;
        padding: 15px;
    }

    .sub-system-item-btn {
        float: right;
        height: 85px;
        width: 90px;
        background: #fff;
        margin: 10px 10px 0 0;
        padding-top: 15px;
        text-align: center;
    }
    .sub-system-item-btn > div,
    .sub-system-item-cont > div {
        height: 30px;
        line-height: 30px;
        padding-bottom: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .sub-system-item-cont .sub-system-item-desc {
        padding-bottom: 0px;
    }

    .sub-system-item-cont * {
        font-size: 14px;
        font-weight: normal;
    }

</style>



// WEBPACK FOOTER //
// website/subComponents/system/list.vue